import { isErrorWithStatus } from '.';

export const isItemNamesTakenInProjectError = isErrorWithStatus( 400, 'invalid_items' );

export const isItemNamesTakenInFolderError = isErrorWithStatus( 400, 'invalid_items' );

export const isFileNameForRoundTakenError = error => isErrorWithStatus( 422 )( error )
    && error.data && error.data.error_message && error.data.error_message.file_filename;
